import { ReservationsFiltersState, ReservationsFiltersActionTypes, READ_RESERVATIONS_FILTERS_REQUEST, READ_RESERVATIONS_FILTERS_SUCCESS, READ_RESERVATIONS_FILTERS_FAILURE } from "store/reducers/room/readReservationsFilters/types";

const defaultState: ReservationsFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function reservations(state = defaultState, action: ReservationsFiltersActionTypes): ReservationsFiltersState {
  switch (action.type) {
    case READ_RESERVATIONS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_RESERVATIONS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_RESERVATIONS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};